import { provideTransloco, Translation, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { environment } from '@environment/environment';
import { TranslocoHttpLoader } from './transloco.loader';
import { firstValueFrom } from 'rxjs';
import { PrimeNG } from 'primeng/config';
import { BrokernetLanguageType, BrokernetLanguageTypeOptions } from './api/backend';

/*At this point, we already tried to fetch the language from the Server, see app.module
* There, we set it to the localStorage. So now, if the user was logged in, the language can be set from there
* If there is no language in localStorage, we take the brower's language, but only if supported*/
export function getAppDefaultLanguage(): BrokernetLanguageType {
  const url = new URL(window.location.href);

  if (url.searchParams.get('lang') === 'en') {
    localStorage.setItem('app-language', BrokernetLanguageType.En);
    return BrokernetLanguageType.En;
  }

  const storedLang = localStorage['app-language'];
  if (storedLang) {
    const validOption = BrokernetLanguageTypeOptions.find(opt => opt.value === storedLang);
    if (validOption) {
      return validOption.value;
    }
  }

  /**
   * TODO: find out how to tell the browser inside the testing pipeline to be in german. If its not german,
   * The tests will fail. For now, we just use german as default instead of the browser's language
   * const browserLang = navigator.language.split('-')[0].toUpperCase() as BrokernetLanguageTypeEnum; // Get browser language code
   */
  const browserLang = BrokernetLanguageType.De;
  const foundOption = BrokernetLanguageTypeOptions.find(opt => opt.value === browserLang);
  return foundOption ? foundOption.value : BrokernetLanguageTypeOptions[0].value;
}

export function preloadLanguage(transloco: TranslocoHttpLoader,
                                translocoService: TranslocoService,
                                primengConfig: PrimeNG) {
  return function (): Promise<Translation> {
    translocoService.selectTranslateObject('primeng').subscribe((translations) => {
      primengConfig.setTranslation(translations);
    });
    return firstValueFrom(transloco.getTranslation(getAppDefaultLanguage()));
  };
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: BrokernetLanguageTypeOptions.map(opt => opt.value),
        defaultLang: getAppDefaultLanguage(),
        prodMode: environment.production,
        reRenderOnLangChange: true
      },
      loader: TranslocoHttpLoader
    }),
    provideAppInitializer(() => {
      const initializeLanguage = preloadLanguage(
        inject(TranslocoHttpLoader),
        inject(TranslocoService),
        inject(PrimeNG)
      );
      return initializeLanguage();
    })
  ]
})

export class TranslocoRootModule {
}
